import React from 'react'
import moment from 'moment-timezone'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import './../assets/table.css'
import EventVerification from './EventVerification'
import ascendIcon from '../images/ascendingIcon.svg'
import descendIcon from '../images/descendingIcon.svg'
import arrowDownIcon from '../images/arrowDownIcon.svg'
import enabledCheckIcon from '../images/enabledCheckIcon.svg'
import like from '../images/like.svg'
import pointsIcon from '../images/3pointsIcon.svg'
import _ from 'lodash'
import LinesEllipsis from 'react-lines-ellipsis'
import Modal from 'react-responsive-modal'
import { Query } from 'react-apollo'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import { EVENT_SELECTED } from '../query/event'
import config from '../config'
import CircularProgress from '@material-ui/core/CircularProgress'
moment.locale('fr')

class EventListContentByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      myValue: '',
      dataFilter: null,
      openModal: false,
      idSelected: null,
      trbImm: null,
      openModalForVerificationSelectEvent: false,
      vehicleDisplayMode: localStorage.getItem('vehicleDisplayMode') || 'registration',
      showVehicleMenu: false
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        dataFilter: null
      })
    }
  }

  toggleVehicleMenu = () => {
    this.setState({
      showVehicleMenu: !this.state.showVehicleMenu
    })
  }

  setVehicleDisplayMode = (mode) => {
    localStorage.setItem('vehicleDisplayMode', mode)
    this.setState({
      vehicleDisplayMode: mode,
      showVehicleMenu: false
    })
  }

  getVehicleDisplay = (element) => {
    if (this.state.vehicleDisplayMode === 'full_label') {
      return this.props.trackableName || element.registration_number
    }
    return element.registration_number
  }

  getSort (key) {
    const self = this
    const columnState = !this.state[key]
    this.setState({
      [key]: columnState,
      dataFilter: _.orderBy(
        self.updateDataStructure(this.props.data),
        [key],
        columnState ? 'asc' : 'desc'
      ),
      myValue: key
    })
  }

  onCloseModal () {
    const self = this
    self.setState({
      openModal: false
    })
  }

  onCloseModalForVerificationSelectEvent () {
    const self = this
    self.setState({
      openModalForVerificationSelectEvent: false
    })
  }

  getHeader () {
    return (
      <Thead style={styles.theadStyle}>
        <Tr>
          <Th height='48px'
            style={styles.thLeft}
            onClick={
              () => this.getSort('end_at')
            }
          >
            <span>Date</span>
            <span className='transparent'>
              {
                this.state.myValue === 'end_at'
                  ? (this.state.end_at === true
                    ? <img
                      style={styles.imgStyle}
                      src={ascendIcon}
                      alt='true'
                    />
                    : <img
                      style={styles.imgStyle}
                      src={descendIcon}
                      alt='true'
                    />)
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
          >
            <div style={styles.vehicleHeaderContainer}>
              <div style={styles.vehicleMenuContainer}>
                <img
                  src={arrowDownIcon}
                  alt='menu'
                  style={styles.menuIcon}
                  onClick={this.toggleVehicleMenu}
                />
                {this.state.showVehicleMenu && (
                  <div style={styles.vehicleDropdownMenu}>
                    <div style={styles.dropdownTitle}>Afficher :</div>
                    <div
                      style={styles.dropdownItem}
                      onClick={() => this.setVehicleDisplayMode('registration')}
                    >
                      {this.state.vehicleDisplayMode === 'registration' && (
                        <img src={enabledCheckIcon} alt='check' style={styles.checkIcon} />
                      )}
                      <span style={this.state.vehicleDisplayMode === 'registration' ? styles.dropdownItemTextActive : styles.dropdownItemText}>
                        Immatriculation
                      </span>
                    </div>
                    <div
                      style={styles.dropdownItem}
                      onClick={() => this.setVehicleDisplayMode('full_label')}
                    >
                      {this.state.vehicleDisplayMode === 'full_label' && (
                        <img src={enabledCheckIcon} alt='check' style={styles.checkIcon} />
                      )}
                      <span style={this.state.vehicleDisplayMode === 'full_label' ? styles.dropdownItemTextActive : styles.dropdownItemText}>
                        Libellé
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <span
                onClick={() => this.getSort('registration_number')}
                style={styles.vehicleHeaderText}
              >
                Véhicules
                <span className='transparent'>
                  { this.state.myValue === 'registration_number'
                    ? (this.state.registration_number === true
                      ? <img
                        style={styles.imgStyle}
                        src={ascendIcon}
                        alt='true'
                      />
                      : <img
                        style={styles.imgStyle}
                        src={descendIcon}
                        alt='true'
                      />)
                    : <img
                      style={styles.imgStyle}
                      src={descendIcon}
                      alt='true'
                    />
                  }
                </span>
              </span>
            </div>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('station')
            }
          >
            <span>Station service</span>
            <span className='transparent'>
              { this.state.myValue === 'station'
                ? (this.state.station === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('value')
            }
          >
            <span>Volume</span>
            <span className='transparent'>
              { this.state.myValue === 'value'
                ? (this.state.value === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('ticket')
            }
          >
            <span>Ticket</span>
            <span className='transparent'>
              { this.state.myValue === 'ticket'
                ? (this.state.ticket === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('checked')
            }
          >
            <span>Vérifié</span>
            <span className='transparent'>
              { this.state.myValue === 'checked'
                ? (this.state.checked === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.thRight}
            onClick={
              () => this.getSort('state')
            }
          >
            <span>Etat</span>
            <span className='transparent'>
              { this.state.myValue === 'state'
                ? (this.state.state === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
        </Tr>
      </Thead>
    )
  }

  getInvalidStateValue (hasTicket, delta) {
    if (hasTicket) {
      return (
        <div>
          <span style={styles.offenseLabel}>Infraction</span><br />
          {delta ? <span style={styles.offenseLabel}>Δ = {delta} %</span> : null}
        </div>
      )
    }
    return (
      <span style={styles.offenseLabel}>Infraction</span>
    )
  }

  getStateValue (state, hasTicket, delta) {
    let value
    switch (state) {
      case '':
        value = <div>
          <span>-</span><br />
          <img
            style={{ marginRight: '-2px' }}
            src={pointsIcon}
            alt='true'
          />
        </div>
        break
      case 'invalid':
        value = this.getInvalidStateValue(hasTicket, delta)
        break
      case 'valid':
        value = <img
          src={like}
          alt='true'
        />
        break
      default:
        value = <div>
          <span>-</span><br />
          <img
            src={pointsIcon}
            alt='true'
          />
        </div>
    }
    return value
  }

  onClickRow (id, state, trbImm, occurredAt) {
    const self = this
    var newUtcDate = new Date().toISOString()
    var diffTime = new Date(newUtcDate).getTime() - new Date(occurredAt).getTime()
    var diffDays = diffTime / (1000 * 3600 * 24)
    var eventValidationDayDifference = config.event_validation_day_difference
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        if (state !== 'valid' && state !== 'invalid') {
          if (diffDays <= eventValidationDayDifference) {
            self.setState({
              openModalForVerificationSelectEvent: true
            })
          } else {
            self.setState({
              openModal: true,
              idSelected: id,
              trbImm: trbImm
            })
          }
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  updateDataStructure (data) {
    let structuredData = []
    data.forEach(function (element, key) {
      let myElement = {}
      for (let k in element) {
        if (k === 'metadata') {
          for (let mykey in element[k]) {
            myElement[mykey] = data[key][k][mykey]
          }
        } else {
          myElement[k] = element[k]
        }
      }
      structuredData.push(myElement)
    })
    return structuredData
  }

  getBody () {
    const self = this
    let data = this.state.dataFilter ? this.state.dataFilter : this.props.data
    data = self.updateDataStructure(data)
    return (
      <Tbody style={styles.tbodyStyle}>
        {data.map((value, key) => {
          return (
            <Tr
              style={{ cursor: value.state === '' ? 'pointer' : null }}
              key={key}
              // onClick={() => self.onClickRow(value.id, value.state, value.registration_number, value.occurred_at)}
            >
              <Td className='tdDateAndTime'>
                <span
                  className='marginHour'>{moment.utc(value.end_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')}
                </span><br />
                <span
                  className='marginHour'>{moment.utc(value.end_at).tz('Indian/Antananarivo').format('HH:mm')}
                </span>
              </Td>
              <Td><span>{this.getVehicleDisplay(value)}</span></Td>
              <Td>
                <span>
                  <LinesEllipsis
                    text={value.gas_station !== '' ? value.gas_station : '-'}
                    maxLine='1'
                    ellipsis='...'
                    trimRight
                    basedOn='letters'
                  />
                </span>
              </Td>
              <Td>
                <span>
                  {Math.round((value.quantity / 100).toFixed(2))} Litres
                </span>
              </Td>
              <Td>
                <span>
                  {value.has_ticket && value.checked ? 'Oui' : (value.checked) ? 'Non' : '-'}
                </span>
              </Td>
              <Td><span>{value.checked ? 'Oui' : <span style={styles.hasNotTicketLabel}>Non</span>}</span></Td>
              <Td className='tdRight'>
                <div style={styles.contentRight}>
                  {this.getStateValue(value.state, value.has_ticket, value.delta)}
                </div>
              </Td>
            </Tr>
          )
        })}
      </Tbody>
    )
  }

  render () {
    return (
      <div style={styles.paper}>
        <div style={styles.content}>
          <div className='eventTableContent'>
            <Table cellSpacing='0' cellPadding='0' style={styles.tableStyle}>
              {this.getHeader()}
              {this.getBody()}
            </Table>
            <div>
              <Modal
                styles={bg}
                open={this.state.openModal}
                onClose={() => this.onCloseModal()}
                showCloseIcon={false}
                center
                focusTrapped={false}>
                <Query
                  query={EVENT_SELECTED}
                  variables={{ id: this.state.idSelected }}
                >
                  {({ data, loading, error }) => {
                    if (!data) {
                      return null
                    }
                    if (error) {
                      return <p>{error.message}</p>
                    }

                    if (loading || this.state.idSelected === null) {
                      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                    }

                    return (
                      <EventVerification
                        onClose={() => this.onCloseModal()}
                        selectedEventId={this.state.idSelected}
                        trbImm={this.state.trbImm}
                        eventSelected={data.events}
                      />
                    )
                  }}
                </Query>
              </Modal>
            </div>
            <div>
              <Modal
                styles={bgVerification}
                open={this.state.openModalForVerificationSelectEvent}
                onClose={() => this.onCloseModalForVerificationSelectEvent()}
                showCloseIcon={false}
                focusTrapped={false}>
                <p style={styles.modalTitleForSelectEvent}>
                  L'événement choisi est trop récent.<br />
                  Il est impossible de l'associer à un ticket pour le moment.
                </p>
                <div style={styles.buttonContentCenter}>
                  <button onClick={() => this.onCloseModalForVerificationSelectEvent()}><span>Fermer</span></button>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const bg = {
  modal: {
    background: '#15191C',
    maxWidth: '1400px',
    overflowX: 'auto'
  }
}

const bgVerification = {
  modal: {
    background: '#364248',
    borderRadius: '6px',
    color: '#F2F2F2'
  }
}

const styles = {
  paper: {
    height: '100vh'
  },
  content: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
    height: 'auto',
    maxHeight: '100vh',
    paddingRight: '10px'
  },
  tableStyle: {
    width: '100%',
    marginTop: '-12px',
    borderSpacing: '0px 12px'
  },
  theadStyle: {
    fontSize: '14px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  thLeft: {
    cursor: 'pointer',
    width: '13%',
    marginLeft: '15px'
  },
  th: {
    cursor: 'pointer',
    position: 'relative',
    width: '14%'
  },
  vehicleHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  vehicleHeaderText: {
    cursor: 'pointer',
    flex: 1
  },
  vehicleMenuContainer: {
    position: 'relative',
    marginRight: '8px'
  },
  menuIcon: {
    width: '12px',
    height: '12px',
    cursor: 'pointer'
  },
  vehicleDropdownMenu: {
    position: 'absolute',
    top: '25px',
    left: '0',
    backgroundColor: '#2C343A',
    border: '1px solid #444',
    borderRadius: '4px',
    padding: '8px',
    minWidth: '180px',
    zIndex: 1000,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
  },
  dropdownTitle: {
    fontSize: '12px',
    color: '#AAA',
    marginBottom: '8px',
    paddingLeft: '8px'
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 8px',
    cursor: 'pointer',
    borderRadius: '3px',
    marginBottom: '4px'
  },
  dropdownItemText: {
    fontSize: '13px',
    color: '#F2F2F2',
    marginLeft: '8px'
  },
  dropdownItemTextActive: {
    fontSize: '13px',
    color: '#7ED321',
    marginLeft: '8px',
    fontWeight: 'bold'
  },
  checkIcon: {
    width: '14px',
    height: '14px'
  },
  thStation: {
    cursor: 'pointer',
    width: '19%'
  },
  thRight: {
    cursor: 'pointer',
    width: '12%',
    textAlign: 'right',
    paddingRight: '15px'
  },
  tbodyStyle: {
    fontSize: '14px',
    height: '80px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  spanVolumes: {
    color: '#7ED321'
  },
  contentRight: {
    marginRight: '15px'
  },
  imgStyle: {
    marginLeft: '20px'
  },
  iconStyle: {
    width: '20px',
    height: '20px'
  },
  transparent: {
    width: '20px',
    height: '20px',
    color: 'transparent'
  },
  offenseLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#FFC400'
  },
  hasNotTicketLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#24CCB8'
  },
  modalTitleForSelectEvent: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  buttonContentCenter: {
    textAlign: 'center'
  }
}

export default EventListContentByVehicleComponent
